import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';

const CodePenGuide = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row>
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 div-shadow mb-3">
          <h1 className="head-color">How to Use CodePen Effectively: A Complete Guide</h1>
          <span className="small ms-2"><b>Publish By:-</b> CodeInputs</span>

          <Row className="mt-3 text-center">
            <Col md={12}>
              <Image src="/graphics/images/codepen.png" alt="CodePen" fluid />
            </Col>
          </Row><br/>

          <h4>Introduction</h4>
          <p className="mt-4 blacktext">
            CodePen is an online code editor that allows developers to write and share front-end code. 
            It supports HTML, CSS, and JavaScript, making it an excellent tool for experimenting, 
            showcasing projects, and learning from others.
          </p>

          <h4>Getting Started with CodePen</h4>
          <h6>1. Creating an Account</h6>
          <p className="mt-4 blacktext">
            To use CodePen, sign up for a free account at <a href="https://codepen.io/">CodePen.io</a>. 
            A free account allows you to create Pens, explore others' work, and follow developers.
          </p>

          <h6>Understanding the Interface</h6>
          <p className="mt-4 blacktext">When you open a new Pen, you'll see three main sections:</p>
          <ul>
            <li><strong>HTML Editor</strong>: Write the markup structure of your project.</li>
            <li><strong>CSS Editor</strong>: Apply styles using CSS or preprocessors like SCSS.</li>
            <li><strong>JavaScript Editor</strong>: Add interactive functionality.</li>
          </ul>

          <h4>Features That Make CodePen Powerful</h4>
          <h5>1. Collections and Templates</h5>
          <p className="mt-4 blacktext">
            Collections group related Pens together, and templates save boilerplate code.
          </p>
          <h5>2. Embedding and Sharing</h5>
          <p className="mt-4 blacktext">
            CodePen makes sharing code easy with embeds, URLs, and presentation mode.
          </p>

          <h4>Best Practices for CodePen</h4>
          <ul>
            <li>Use descriptive titles & tags for discoverability.</li>
            <li>Write clean, modular code with comments.</li>
            <li>Leverage external libraries like Bootstrap and jQuery.</li>
            <li>Engage with the CodePen community.</li>
          </ul>

          <h4>Conclusion</h4>
          <p className="mt-4 blacktext">
            CodePen is a fantastic platform for front-end developers to experiment, learn, and share code. 
            Whether you're a beginner or an expert, the features and community support make it an invaluable tool.
          </p>
        </Col>

        <Col sm={3} className="recent-post">
          <Card className="bg-white p-4 mb-3 div-shadow">
            <h4 className="head-color">Recent Post</h4>
            <RecentPost />
          </Card>
          <Card className="bg-white p-4 div-shadow">
            <h4 className="mt-4 head-color">Recent Comment</h4>
            <p style={{ color: "#85929e" }}>No Comments to Show</p>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer />
    </>
  );
};

export default CodePenGuide;